import React from 'react';

const CustomLegend = ({ payload }) => (
  <ul className="chart__legend">
    {payload.map((entry, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <li key={`item-${index}`}>
        <span style={{ backgroundColor: entry.color }} className="chart__legend__disk" />
        {entry.value}
      </li>
    ))}
  </ul>
);

export default CustomLegend;
